
export type GetUserStats200AchievementsItem = {
  description?: string;
  id?: string;
  /**
   * @minimum 0
   * @maximum 100
   */
  progress?: number;
  title?: string;
};
